import {React, useState, useEffect} from "react";

const Word = ({id, game}) => {

    const [word, setWord] = useState('     ');
    const [classes, setClasses] = useState('     ');

    useEffect(() => {

        game.RegisterWord(id, setWord, setClasses);

    }, [id, game]);

    useEffect(() => {

        console.log(classes);    

    }, [classes]);

    return (
        <div className="word">
        
            <input type="text" maxLength="1"  value={word[0]} readOnly className={ classes[0] === 'g' ? 'green' : classes[0] === 'o' ? 'orange' : 'white' } />
            <input type="text" maxLength="1"  value={word[1]} readOnly className={ classes[1] === 'g' ? 'green' : classes[1] === 'o' ? 'orange' : 'white' } />
            <input type="text" maxLength="1"  value={word[2]} readOnly className={ classes[2] === 'g' ? 'green' : classes[2] === 'o' ? 'orange' : 'white' } />
            <input type="text" maxLength="1"  value={word[3]} readOnly className={ classes[3] === 'g' ? 'green' : classes[3] === 'o' ? 'orange' : 'white' } />
            <input type="text" maxLength="1"  value={word[4]} readOnly className={ classes[4] === 'g' ? 'green' : classes[4] === 'o' ? 'orange' : 'white' } />
            
        </div>
    )

}

export default Word;
